import { useEffect, useState } from 'react'
import { CIMSBasicFieldProps } from '../../../CIMSBasicFields/types'
import { useFoundCallback } from './useFoundCallback'
import { NumberValue } from '../../types'

export function useNumberCustomFields(
  numberValues?: NumberValue[]
): CIMSBasicFieldProps[] {
  const [fields, setFields] = useState<CIMSBasicFieldProps[]>([])
  const found = useFoundCallback()
  useEffect(() => {
    if (!numberValues) return
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    setFields(
      numberValues.map(({ customFieldId, value, customField }) =>
        found({ customField, customFieldId, children: value })
      )
    )
  }, [found, numberValues])
  return fields
}
